import 'bootstrap';
import React from 'react';
import Filters from '../Filters/section4';
import getDoc from "../../qdoc";
import TableTop from '../Table/topdonors';
import TableKey from '../Table/topdonorsKey'; 



export default class Section4 extends React.Component {
  constructor(props) {
    super(props);
    
  }
  
  render() {
    return (
      <div id="S4" className="container">
        <section className="biggest_donors mb-5">
        <div className="apptitle mx-auto mb-3 mt-5">
          <h3>BIGGEST DONORS</h3>
          <div className="desc">
            <p>Who gave a $500,000 lump sum to the NDP in British Columbia? How much did Adam Moryto, a former Queen’s Park intern, donate during the last PC leadership race in Ontario? This tool shows the biggest donors and largest single donations in Canada. For the purposes of clarity, only donations made by contributors with the exact same name appear on this list. “Bell Aliant” and “Bell Canada,” for instance are listed separately.</p>
            <p>To see the top ten donors in every province and territory — including donations made by companies and their subsidiaries — click <a href="https://shielded-basin-79840.herokuapp.com/political-donations/donors">here</a>.</p>

            {/* <p>Wealthy Canadians, and wealthy foreigners, seek to influence Canadian elections by donating hefty sums. This tool can be used to look up the biggest donors to a specific candidate. For example, type in “Kathleen Wynne’ in the recipient box to see the biggest donors to her 2013 Liberal leadership campaign. It can also be used to see the biggest donors to a political party, or simply to all politicians in one province. Please note that the database only combines donations made by contributors with the exact same name so “Bell Aliant” and “Bell Canada” are counted separately. If you want to see the top ten donors in every province and territory with subsidiaries counted under the same name, those lists are available here.</p> */}
          </div>
        </div>
          <div className="row flex-wrap justify-content-around align-items-start mt-5">
            <div className="col-lg-3 borderbottom">
              <span style={{textTransform: 'uppercase', fontSize: '20px'}} className="textgreen">Learn more</span>
              <p>Search for a particular donor, recipient, political party, or region.</p>
              <Filters/>
            </div>
            <div className="p-2 col-lg-5 borderleft textcenter">             
              <TableTop qStateName="State1"/>                 
            </div>
            <div className="p-2 col-lg-4 textcenter">
              <TableKey qStateName="State1"/>
            </div>
            
          </div>  
        </section>  
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./components/Sections/section4.js